// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"eeb4f7c2b5e3c52c0dbf","1642":"a118a4db4cfaa015f956","2983":"9d41be10d7230ba4a72f","5771":"a4e2a98efcfb7393c5bd","5810":"8dfb2392d7107957a510"}[chunkId] + "";
};